

/* eslint-disable prefer-arrow-callback */
import {createRoot} from 'react-dom/client'
import getRoot from './getRoot';
import createStore from './createStore';
import commonInit from './commonInit';
import config from './config';
import Raven from 'raven-js';
// eslint-disable-next-line import/no-unresolved
import '/assets/sass/app.scss';

require('es6-promise').polyfill();

commonInit(function initReady() {
  try {
    if (config.uiConfig && config.uiConfig.sentryDns) Raven.config(config.uiConfig.sentryDns).install();
  } catch (err) {
    console.error(err);
  }
  const store = createStore(typeof window !== 'undefined' ? window.STATE : {});
  const app = getRoot(store);
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(app);
});
